import StepCompletionLink from '@cohort/merchants/apps/common/triggers/StepCompletionLink';
import {TIKTOK_URL} from '@cohort/shared/apps/tiktok/common';
import type {TikTokCommentTiktokVerificationAttemptData} from '@cohort/shared/apps/tiktok/triggers/commentTiktok';
import {Trans} from 'react-i18next';

const TikTokCommentTiktokTriggerStepCompletionTitleComponent: React.FC<{
  data: TikTokCommentTiktokVerificationAttemptData;
  completionSuccess: boolean;
}> = ({data}) => {
  const userLink = `${TIKTOK_URL}/@${data.username}`;

  return (
    <Trans
      i18nKey="triggers.comment-tiktok.stepCompletionTitleComponent.success"
      ns="app-tiktok"
      values={{username: data.username}}
      components={{
        userLink: <StepCompletionLink url={userLink} />,
        tiktokLink: <StepCompletionLink url={data.url} />,
      }}
    />
  );
};

export default TikTokCommentTiktokTriggerStepCompletionTitleComponent;
